<template>
  <section class="w-100 h-100 d-flex flex-column align-center justify-center">
    <div style="width: 100%" class="d-flex flex-column align-center justify-center">
      <CardExibicaoNoticiasModeradas
          :cor-background="corBackground"
          :cor-card-noticias="corCardNoticias"
          :noticias-moderadas="noticiasModeradas"
          :cor-portal="corPortal"
          :logo-portal="logoPortal"
      />
    </div>
  </section>
</template>

<script>
import CardExibicaoNoticiasModeradas from "@/components/Cards/Noticias/CardExibicaoNoticiasModeradas.vue";
import { apiClient } from "@/services/api";
import { mapActions, mapGetters } from "vuex";
export default {
  components: { CardExibicaoNoticiasModeradas },
  data() {
    return {
      codProducao: null,
      codPortal: null,
      timer: null,
      corPortal: null,
      logoPortal: null,
      producao: null,
    };
  },
  async created() {
    if (!this.$store.state.users.isAuthenticated) {
      apiClient.interceptors.request.use(
          (config) => {
            const token = this.$route.query.token || null;

            if (token) {
              config.headers["x-access-token"] = token;
            }
            return config;
          },
          (error) => {
            console.error(error);
            return Promise.reject(error);
          }
      );
    }
    if (
        JSON.parse(localStorage.getItem("@socialcam/selected_option_production")) == null &&
        this.$route.query.cod_producao == null
    ) {
      await this.$router.push({name: "login"});
      return;
    }
    this.getLocalStorageValues();
    if (this.codPortal) {
      await this.handlePortal();
    }
    if (this.codProducao) {
      await this.getProducao();
    }
    this.updateTimer();
  },
  computed: {
    ...mapGetters({
      noticiasModeradas: "noticias/getterNoticiasModeradas",
      portal: "portais/getterSelectedPortal",
      portais: "portais/getterPortais",
      selectedProducao: "producoes/getterProducao",
      darkMode: "producoes/getterDarkMode",
    }),
    isDarkMode() {
      return this.darkMode;
    },
    corBackground() {
      return this.selectedProducao?.dsc_hex_background_chroma_noticias || "#FFFFFF";
    },
    corCardNoticias() {
      if (this.isDarkMode) {
        return "#2D2D2D";
      }
      return "#FFFFFF";
    }
  },
  methods: {
    ...mapActions({
      getNoticiasModeradas: "noticias/getNoticiasModeradas",
      getPortais: "portais/getPortais",
      setSelectedPortal: "portais/setSelectedPortal",
      setSelectedProducao: "producoes/setSelectedProducao",
    }),
    getLocalStorageValues() {
      this.codProducao =
          localStorage.getItem("@socialcam/selected_option_production") ||
          parseInt(this.$route.query.cod_producao) ||
          null;
      this.codPortal =
          localStorage.getItem("@socialcam/cod_portal") ||
          this.$route.query.cod_portal ||
          null;
      setInterval(() => {
        this.codProducao =
            localStorage.getItem("@socialcam/selected_option_production") ||
            parseInt(this.$route.query.cod_producao) ||
            null;
        this.codPortal =
            localStorage.getItem("@socialcam/cod_portal") ||
            this.$route.query.cod_portal ||
            null;
      }, 1000);
    },
    async getProducao() {
      await apiClient
          .get(`listarDadosProducao/${this.codProducao}`)
          .then((response) => {
            this.producao = response.data.producao;
            this.setSelectedProducao(response.data.producao);
          })
          .catch((error) => {
            console.error("Error fetching producao:", error);
          });

      setInterval(async () => {
        await apiClient
            .get(`listarDadosProducao/${this.codProducao}`)
            .then((response) => {
              this.producao = response.data.producao;
              const currentProducao = this.$store.state.producoes.selectedProducao;
              if (!currentProducao || this.hasProducaoChanged(currentProducao, response.data.producao)) {
                this.setSelectedProducao(response.data.producao);
              }
            })
            .catch((error) => {
              console.error("Error fetching producao:", error);
            });
      }, 3000);
    },

    hasProducaoChanged(oldProducao, newProducao) {
      if (!oldProducao || !newProducao) return true;

      const normalize = (val) => val === null || val === undefined ? '' : String(val);

      return (
          normalize(oldProducao.dsc_hex_background_chroma_noticias) !== normalize(newProducao.dsc_hex_background_chroma_noticias) ||
          Boolean(oldProducao.dsc_hex_background_card_noticias) !== Boolean(newProducao.dsc_hex_background_card_noticias) ||
          oldProducao.cod_producao !== newProducao.cod_producao ||
          normalize(oldProducao.sig_producao) !== normalize(newProducao.sig_producao) ||
          normalize(oldProducao.nome_producao) !== normalize(newProducao.nome_producao) ||
          normalize(oldProducao.dsc_producao) !== normalize(newProducao.dsc_producao) ||
          normalize(oldProducao.flg_ativo) !== normalize(newProducao.flg_ativo)
      );
    },

    async handlePortal() {
      await this.getPortais();
      const selectedPortal = this.portais.filter(
          (item) => item.cod_portal === this.codPortal
      )[0];

      if (selectedPortal) {
        this.corPortal = selectedPortal.hex_cor;
        this.logoPortal = selectedPortal.img_logo_portal;
        await this.setSelectedPortal(selectedPortal);
      }
    },
    updateTimer() {
      clearInterval(this.timer);
      this.timer = setInterval(async () => {
        await this.getData();
      }, 3000);
    },
    async getData() {
      if (this.codProducao && this.codPortal) {
        await this.getNoticiasModeradas({
          cod_producao: this.codProducao,
          cod_portal: this.codPortal,
          page: 1,
          size: 20,
          filtro_texto: "",
        });
      }
    },
  },
  watch: {
    async codPortal() {
      if (this.codPortal) {
        await this.handlePortal();
        await this.getData();
      }
    },
    async codProducao() {
      if (this.codProducao) {
        await this.getProducao();
        await this.getData();
      }
    },
    selectedProducao: {
      handler(newValue, oldValue) {
        if (newValue && oldValue &&
            (newValue.dsc_hex_background_chroma_noticias !== oldValue.dsc_hex_background_chroma_noticias ||
                newValue.dsc_hex_background_card_noticias !== oldValue.dsc_hex_background_card_noticias)) {
          this.$forceUpdate();
        }
      },
      deep: true,
      immediate: false
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
};
</script>